import { Injectable } from '@angular/core';
import { ContentType, NotebookCellFacade } from '@mode/notebooks/contract';
import { Store } from '@ngrx/store';

import * as NotebookCellActions from './notebook-cell.actions';
import * as LegacyNotebookCellSelectors from '../notebook-cell/legacy-notebook-cell.selectors';

@Injectable()
export class NotebookCellService implements NotebookCellFacade {
  selectedCellFrozen$ = this.store.select(LegacyNotebookCellSelectors.selectedCellFrozen);
  constructor(private store: Store) {}
  updateContentType(contentType: ContentType, cellToken: string): void {
    this.store.dispatch(NotebookCellActions.UpdateContentType({ contentType, cellToken }));
  }

  editCellContent(content: string, cellToken: string): void {
    this.store.dispatch(NotebookCellActions.editCellContent({ content, cellToken }));
  }
  beginEditCell(cellToken: string): void {
    this.selectedCellFrozen$.subscribe((cellFrozen) => {
      this.store.dispatch(NotebookCellActions.beginEditCell({ cellToken, cellFrozen }));
    });
  }
}
